module.exports = __webpack_public_path__ + "static/slide1.095a8d26.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide1.jpeg
// module id = 1702
// module chunks = 173894859265406